import request from '@/utils/request'
import { IJobCampusData } from './types'

export const defaultCampusData: IJobCampusData = {
  id: 0,
  jobTitle: '',
  city: '',
  jobDesc: '',
  JobDemand: '',
  graduatetime: '2021.9~2022.9'
}

export const selectCampusInfo = (params: any) =>
  request({
    url: '/job/selectCampusInfo',
    method: 'get',
    params
  })
export const insertCampusInfo = (data: any) =>
  request({
    url: '/job/insertCampusInfo',
    method: 'post',
    data
  })
export const updateCampusInfo = (id: number, data: any) =>
  request({
    url: `/job/updateCampusInfo/${id}`,
    method: 'post',
    data
  })
  export const deleteCampusInfo = (id: number) =>
  request({
    url: '/job/deleteCampusInfo/' + id,
    method: 'delete'
  })